module.exports = __webpack_public_path__ + "88eab064cea5b15e8f755c739ff55db0.svg";